import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Reporte from './components/Reporte';
import ModalDirecciones from "./components/ModalDirecciones";
import './App.css';
import logo from './logotitulo.png';
import comunasjson from './comunas.json'
import { ClipLoader } from 'react-spinners'; // Importar el spinner
import { Helmet } from 'react-helmet';




function App() {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL || "http://localhost:5000";

  const [comunas, setComunas] = useState([]);
  const [comunaSeleccionada, setComunaSeleccionada] = useState(null);
  const [comunaSeleccionada_d, setComunaSeleccionada_d] = useState(null);
  const [manzana, setManzana] = useState('');
  const [predio, setPredio] = useState('');
  const [direccion, setDireccion] = useState('');
  const [depto, setdepto] = useState('');
  const [resultado, setResultado] = useState(null);
  const [construcciones, setConstrucciones] = useState([]);
  const [construccionesAgr, setConstruccionesAgr] = useState([]);
  const [error, setError] = useState('');
  const [modalAbierto, setModalAbierto] = useState(false);
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [tabActivo, setTabActivo] = useState('direccion'); // Estado para manejar la pestaña activa
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    const fetchComunas = async () => {
          const opciones = comunasjson.map(comuna => ({
            value: comuna.codigo,
            label: comuna.nombre,
          }));
          setComunas(opciones);
    };
    fetchComunas();
  }, []);

  const resetearBusqueda = () => {
    setResultado(null); // Limpiar el reporte
    setConstrucciones([]); // Limpiar las construcciones
    setResultadosBusqueda([]); // Limpiar los resultados del modal
    setModalAbierto(false); // Cerrar el modal
    setError(''); // Limpiar mensajes de error
  };

const buscarPropiedadTradicional = async (comuna, manzanaParam, predioParam) => {
    resetearBusqueda();
    setCargando(true)
    // if (!comunaSeleccionada || !manzana || !predio) {
    //   setError("Ingrese un rol");
    //   return;
    // }

    try {
    // Buscar propiedad
    const responsePropiedad = await fetch(
      `${SERVER_URL}/buscar?comuna=${comuna}&manzana=${manzanaParam}&predio=${predioParam}`
    );
    const dataPropiedad = await responsePropiedad.json();

    if (responsePropiedad.ok) {
      setResultado(dataPropiedad);
      setError('');
    } else {
      setError(dataPropiedad.error);
      setResultado(null);
      return; // Si la propiedad no se encuentra, no continuar con las construcciones
    }
  } catch (err) {
    setError('Error al conectar con el servidor');
    setResultado(null);
    return; // Si hay un error en la propiedad, no continuar con las construcciones
  }

  // Buscar construcciones tradicionales
  try {
    const responseConstrucciones = await fetch(

      //`http://localhost:5000/construcciones?comuna=${comuna}&manzana=${manzanaParam}&predio=${predioParam}`
        `${SERVER_URL}/construcciones?comuna=${comuna}&manzana=${manzanaParam}&predio=${predioParam}`
    );
    const dataConstrucciones = await responseConstrucciones.json();

    if (responseConstrucciones.ok) {
      setConstrucciones(dataConstrucciones);
    } else {
      setConstrucciones([]); // Solo resetea construcciones si esta solicitud falla
      console.error("Error en construcciones:", dataConstrucciones.error);
    }
  } catch (err) {
    setConstrucciones([]); // Solo resetea construcciones si hay un error
    console.error("Error al obtener construcciones:", err);
  }

  // Buscar construcciones agrícolas
  try {
    const responseConstruccionesAgr = await fetch(
      `${SERVER_URL}/construcciones_agr?comuna=${comuna}&manzana=${manzanaParam}&predio=${predioParam}`
    );
    const dataConstruccionesAgr = await responseConstruccionesAgr.json();

    if (responseConstruccionesAgr.ok) {
      setConstruccionesAgr(dataConstruccionesAgr);

    } else {
      setConstruccionesAgr([]); // Solo resetea construccionesAgr si esta solicitud falla
      console.error("Error en construcciones_agr:", dataConstruccionesAgr.error);
    }
  } catch (err) {
    setConstruccionesAgr([]); // Solo resetea construccionesAgr si hay un error
    console.error("Error al obtener construcciones_agr:", err);
  } finally {
    setCargando(false)
  }
};

  const buscarPorDireccion = async () => {
    resetearBusqueda();

    if (!comunaSeleccionada_d || !direccion) {
      setError("Seleccione una comuna e ingrese una dirección");
      return;
    }

    try {
      setCargando(true);
      const response = await fetch(
        `${SERVER_URL}/buscar_direccion?comuna=${comunaSeleccionada_d.value}&direccion=${direccion}&depto=${depto}`
      );
      const data = await response.json();


      if(data.length === 1){
        seleccionarPropiedad(data[0]);
      }
      else if(data.length > 1){
        setResultadosBusqueda(data); // Almacenar resultados de la búsqueda
        setModalAbierto(true); // Abrir el modal
        setError('');
      }
      else{
        setError(data.error || 'No se encontraron resultados.');
        setResultadosBusqueda([]);
      }

    } catch (err) {
      setError('Error al conectar con el servidor');
      console.error(err);
      setResultadosBusqueda([]);
    } finally {
      setCargando(false)
    }
  };

  const seleccionarPropiedad = (propiedad) => {

    setModalAbierto(false); // Cerrar el modal después de seleccionar

    buscarPropiedadTradicional(propiedad.comuna,propiedad.manzana, propiedad.predio);
  };

  const BuscarPorRol = async () => {
    buscarPropiedadTradicional(comunaSeleccionada.value,manzana, predio);
  };

  const manejarTeclaEnter = (event, tipoBusqueda) => {
  if (event.key === "Enter") {
    if (tipoBusqueda === "rol") {
      BuscarPorRol();
    } else if (tipoBusqueda === "direccion") {
      buscarPorDireccion();
    }
  }
};


  return (

      <div className="main-container">
        <Helmet>
          <meta property="og:title" content="Propiedata - Datos oficiales de propiedades"/>
          <meta property="og:description"
                content="Consulta superficies, avalúos y características de propiedades en Chile."/>
          <meta property="og:url" content="https://propiedata.cl"/>
          <meta property="og:type" content="website"/>
        </Helmet>


        <div className="App">


          <div className="header">
            <img src={logo} alt="logo" className="logo"/>
            <div className="header-divider"></div>
            <div className="header-subtitle">
              <h2>Encuentra datos claves de cualquier propiedad inmobiliaria en Chile</h2>
              <p className="features">Superficie terreno | Superficie y características construcciones | Avalúo
                fiscal</p>
            </div>
          </div>


          {/* Pestañas */}
          <div className="tabs">
            <button
                className={tabActivo === 'direccion' ? 'active' : ''}
                onClick={() => setTabActivo('direccion')}
            >
              Buscar por Dirección
            </button>
            <button
                className={tabActivo === 'rol' ? 'active' : ''}
                onClick={() => setTabActivo('rol')}
            >
              Buscar por Rol
            </button>

          </div>

          {/* Contenedor de búsqueda por Rol */}
          {tabActivo === 'rol' && (
              <div className="search-container">
                <div className="react-select-container">
                  <Select
                      options={comunas}
                      value={comunaSeleccionada}
                      onChange={(selectedOption) => setComunaSeleccionada(selectedOption)}
                      placeholder="Comuna"
                      isSearchable={true}
                  />
                </div>
                <input
                    type="text"
                    placeholder="Manzana"
                    value={manzana}
                    onChange={(e) => setManzana(e.target.value)}
                    onKeyDown={(e) => manejarTeclaEnter(e, "rol")}
                />
                <input
                    type="text"
                    placeholder="Predio"
                    value={predio}
                    onChange={(e) => setPredio(e.target.value)}
                    onKeyDown={(e) => manejarTeclaEnter(e, "rol")}
                />
                <button onClick={BuscarPorRol}>Buscar</button>
              </div>
          )}

          {/* Contenedor de búsqueda por Dirección */}
          {tabActivo === 'direccion' && (
              <div className="search-container-direccion">
                <div className="react-select-container">
                  <Select
                      options={comunas}
                      value={comunaSeleccionada_d}
                      onChange={(selectedOption) => setComunaSeleccionada_d(selectedOption)}
                      placeholder="Comuna"
                      isSearchable={true}
                  />
                </div>
                <input
                    type="text"
                    placeholder="Dirección"
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
                    onKeyDown={(e) => manejarTeclaEnter(e, "direccion")}
                />
                <input
                    type="numero"
                    placeholder="Depto/Casa"
                    value={depto}
                    onChange={(e) => setdepto(e.target.value)}
                    onKeyDown={(e) => manejarTeclaEnter(e, "direccion")}
                />
                <button onClick={buscarPorDireccion}>Buscar</button>
              </div>
          )}

          {/* Mensaje de error */}
          {error && <p className="error-message">{error}</p>}

          {/* Indicador de espera */}
          {cargando && (
              <div className="cargando">
                <ClipLoader color="#36d7b7" size={50}/> {/* Personaliza el color y tamaño */}
              </div>
          )}
          {/* Mostrar el reporte */}

          <Reporte resultado={resultado} construcciones={construcciones} construccionesAgr={construccionesAgr}/>

          {/* Usar el componente ModalBusqueda */}
          {modalAbierto && (
              <ModalDirecciones
                  resultadosBusqueda={resultadosBusqueda}
                  onSeleccionarPropiedad={seleccionarPropiedad}
                  onCerrarModal={() => setModalAbierto(false)}
              />
          )}


        </div>


        <footer className="app-footer">
          <div className="footer-content">
            <p>© {new Date().getFullYear()} - propiedata.cl | contacto@propiedata.cl</p>
            <p className="disclaimer">
              <small>
                Los datos se obtienen de fuentes oficiales y se encuentran actualizados hasta el 1° semestre de 2025.
                Propiedata no garantiza la exactitud de la información.
              </small>
            </p>
          </div>
        </footer>

      </div>
  );
}

export default App;